//
// RadioBoxList.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../../lib";
import "../PromptSpecialization";
import "../../../dataDefinition/DataItem";

var RadioBoxList = createModule("BIRD::RadioBoxList", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel","BIRD::PromptSpecialization"], EventDispatcher, [
    ,
    {
        valueVariable: 1,
        measureVariable: 1,
        searchable: 2,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default RadioBoxList;
